export default __webpack_public_path__ + "static/media/psh.982b03eb.png";